<template>
  <div
    class="form-fields row">
    <div
      class="form-field"
      :class="{
        'col-lg mb-3': !field.type.includes('layout'),
        'w-100': field.type.includes('layout'),
        'px-3': field.type === 'layout-linebreak',
      }"
      v-for="field in formFields"
      :key="field.id">

      <!-- Fields / Static Elements -->
      <div v-if="!field.type.includes('layout')">
        <!-- Label -->
        <label
          v-if="field.type !== 'checkbox' && !field.type.includes('static')"
          :for="`form-field-${field.id}`">
          <div>
            {{field.label}}
            <small v-if="field.required" class="text-danger">required</small>
          </div>
        </label>
        <!-- / Label -->

        <!-- Text -->
        <b-form-input
          :id="`form-field-${field.id}`"
          v-if="field.type === 'text'"
          :readonly="isReadonly"
          v-model="formData[field.name]"
          type="text">
        </b-form-input>
        <!-- / Text -->

        <!-- Number -->
        <b-form-input
          :id="`form-field-${field.id}`"
          v-if="field.type === 'number'"
          :readonly="isReadonly"
          v-model="formData[field.name]"
          type="number">
        </b-form-input>
        <!-- / Number -->

        <!-- Dropdown -->
        <b-form-select
          :id="`form-field-${field.id}`"
          :readonly="isReadonly"
          v-model="formData[field.name]"
          v-if="field.type === 'dropdown'">
          <option selected :value="undefined">Select Option</option>
          <option
            v-for="o in field.options"
            :key="o"
            :value="o">
            {{o}}
          </option>
        </b-form-select>
        <!-- / Dropdown -->

        <!-- Textarea -->
        <b-form-textarea
          :id="`form-field-${field.id}`"
          :readonly="isReadonly"
          v-model="formData[field.name]"
          rows="3"
          v-if="field.type === 'textarea'"
        />
        <!-- / Textarea -->

        <!-- Checkbox -->
        <b-form-checkbox
          v-if="field.type === 'checkbox'"
          :readonly="isReadonly"
          v-model="formData[field.name]">
          {{field.label}}
          <span v-if="field.required" class="text-danger">(required)</span>
        </b-form-checkbox>
        <!-- / Checkbox -->
      </div>
      <!-- / Fields / Static Elements -->

      <!-- New Line  -->
      <div
        style="font-size: 14px;"
        v-if="field.type === 'layout-linebreak' && !isHideButtons">
        New Line
      </div>
      <!-- / New Line -->

      <!-- Horizontal Rule  -->
      <hr
        :class="{'mb-0':!isHideButtons}"
        v-if="field.type === 'layout-hr'">
      <!-- / Horizontal Rule -->

      <!-- Paragraph -->
      <p v-if="field.type === 'static-paragraph'">
        {{field.label}}
      </p>
      <!-- / Paragraph -->

      <!-- Header -->
      <h2 v-if="field.type === 'static-header'">
        {{field.label}}
      </h2>
      <!-- / Header -->

      <!-- Header -->
      <a
        v-if="field.type === 'static-link'"
        :href="field.meta.url"
        target="_blank">
        {{field.label}}
      </a>
      <!-- / Header -->

      <!-- Edit / Delete Field -->
      <div
        v-if="!isHideButtons"
        class="d-flex ml-n2"
        :class="{
          'mb-2': field.type.includes('layout'),
          'px-3': field.type === 'layout-hr',
        }">
        <b-button
          type="button"
          size="sm"
          variant="link"
          @click="$emit('edit-field', field)">
          Edit
        </b-button>

        <b-button
          type="button"
          variant="link"
          size="sm"
          @click="$emit('delete-field', field.id)">
          Delete
        </b-button>
      </div>
      <!-- / Edit / Delete Field -->
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'form-fields',
  props: [
    'value',
    'formFields',
    'hideButtons',
    'readonly',
  ],
  data() {
    return {
      formData: _.clone(this.value) || {},
      isReadonly: this.readonly === '',
    };
  },
  watch: {
    formData: {
      deep: true,
      handler(data) {
        this.$emit('input', data);
      },
    },
  },
  computed: {
    isHideButtons() {
      return this.hideButtons === '' || this.hideButtons === true;
    },
  },
};
</script>

<style lang="scss">
[readonly] {
  background-color: #ffffff !important;
  pointer-events: none;
}
</style>
